import $ from 'jquery'

const Validation = (($) => {

	class Validation {

		constructor(){
			this._validators = {}
			this._messages = []
			this._data = {}
		}

		addValidator(field, validator){
			if(!this._validators[field]){
				this._validators[field] = [];
			}

			this._validators[field].push(validator)
		}

		validate(data){

			this._data = data;
			this._messages = [];

			for(field in this._validators){
				this._validators[field].forEach(function(validator,index){
					validator.validate(self, field)
				})
			}

			return this._messages
		}

		getValue(field){
			if(this._data && this._data[field]){
				return this._data[field]
			}
			return null
		}



	}

	return Validation
})($)

export default Validation
